import { render, staticRenderFns } from "./AddCategoryList.vue?vue&type=template&id=1b8c33e5"
import script from "./AddCategoryList.vue?vue&type=script&lang=js"
export * from "./AddCategoryList.vue?vue&type=script&lang=js"
import style0 from "./AddCategoryList.vue?vue&type=style&index=0&id=1b8c33e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports